module.exports = __webpack_public_path__ + "static/img/公司8.e57b005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司8.jpg
// module id = zTvC
// module chunks = 1